import React from 'react'
import PropTypes from 'prop-types'
import { If } from '../../../../../../deprecated/Conditionals'
import PrequalRequested from '../../PrequalRequested'
import GetPrequal from './GetPrequal'

const propTypes = {
  prequalRequested: PropTypes.bool,
}

const NoPrequalScreen = ({ prequalRequested }) => (
  <>
    <If condition={prequalRequested}>
      <PrequalRequested />
    </If>
    <If condition={!prequalRequested}>
      <GetPrequal />
    </If>
  </>
)

NoPrequalScreen.propTypes = propTypes

export default NoPrequalScreen
